import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const box = geo.createNode('box');

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [box],
		autoLayout: true,
	};
}
// export const sopBox = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/box`,
// 		createData,
// 		relatedNodes: [BoxSopNode],
// 	}),
// ];
